// extracted by mini-css-extract-plugin
export var menuIcon = "_tg-0";
export var menuIconInline = "_tg-1";